import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PALETA = [
  { nombre: 'Verde esmeralda', hex: '#1F6F54' },
  { nombre: 'Verde oliva', hex: '#6B7A4F' },
  { nombre: 'Azul marino', hex: '#273B53' },
  { nombre: 'Vino', hex: '#6E2B3A' },
  { nombre: 'Terracota', hex: '#B0623C' },
  { nombre: 'Dorado', hex: '#B8995A' },
  { nombre: 'Marfil', hex: '#EFE7D6' },
  { nombre: 'Lavanda', hex: '#9A8FB0' },
  { nombre: 'Gris piedra', hex: '#8A8A8A' },
  { nombre: 'Negro', hex: '#1A1A1A' },
];

export const TIPOS_BENEFICIO = [
  { valor: 'porcentaje', etiqueta: 'Porcentaje' },
  { valor: 'valor', etiqueta: 'Valor fijo' },
  { valor: 'otro', etiqueta: 'Otro' },
];

export const PCT_REFERIDO = 10;
export const PUNTOS_REFERIDO = 200;

export const PASOS = ['La pareja', 'El evento', 'Colores', 'Beneficio', 'Revisión'];
export const MAX_COLORES = 4;

export const ESTADO_LABEL = { borrador: 'Borrador', publicada: 'Publicada', despublicada: 'Despublicada' };
export const ESTADO_CLASE = {
  borrador: 'bg-amber-100 text-amber-800',
  publicada: 'bg-green-100 text-green-800',
  despublicada: 'bg-neutral-200 text-neutral-700',
};

export const ESTADOS_SOLICITUD = [
  { valor: 'nuevo', etiqueta: 'Nuevo' },
  { valor: 'contactado', etiqueta: 'Contactado' },
  { valor: 'convertido', etiqueta: 'Compró' },
  { valor: 'descartado', etiqueta: 'Descartado' },
];

export const textoBeneficio = (tipo, valor) => {
  const v = (valor || '').toString().trim();
  if (!v) return '';
  return tipo === 'porcentaje' && /^\d+([.,]\d+)?\s*%?$/.test(v) ? `${v.replace(/\s*%$/, '')}% de descuento` : v;
};

export const hexValido = (hex) => /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test((hex || '').trim());

export const slugPareja = (a, b) =>
  `${a}-y-${b}`.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, 'y').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');

export const urlBoda = (slug) => `${process.env.REACT_APP_DOMINIO_PRINCIPAL}/bodas/${slug}`;
export const urlCompartirBoda = (slug) => `${process.env.REACT_APP_DOMINIO_PRINCIPAL}/api/invitacion/${slug}`;
export const urlReferido = (codigo) => `${process.env.REACT_APP_DOMINIO_PRINCIPAL}/api/referido/${codigo}`;

export const waLink = (numero, texto) => (numero ? `https://wa.me/${numero}?text=${encodeURIComponent(texto)}` : null);

export const mensajeWhatsApp = (variante, datos, contacto) => {
  const marca = contacto?.marca_nombre || 'Juan Pablo Murillo';
  if (variante === 'referido') {
    return `Hola, vengo referido por ${datos.nombre_referente}. Quisiera recibir asesoría con ${marca} y aplicar mi ${datos.beneficio_valor}% de descuento.`;
  }
  return `Hola, vengo de la página de beneficios de la boda de ${datos.persona_a} y ${datos.persona_b}. Quisiera recibir asesoría para mi traje y conocer el beneficio disponible.`;
};

export const formatFecha = (iso) =>
  iso ? new Date(iso).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';

const staff = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const cliente = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('mi_jpm_token')}` } });

export const bodasApi = {
  listar: () => axios.get(`${API_URL}/api/bodas/admin`, staff()).then(r => r.data),
  obtener: (slug) => axios.get(`${API_URL}/api/bodas/admin/${slug}`, staff()).then(r => r.data),
  crear: (campos) => axios.post(`${API_URL}/api/bodas/admin`, campos, staff()).then(r => r.data),
  editar: (slug, campos) => axios.put(`${API_URL}/api/bodas/admin/${slug}`, campos, staff()).then(r => r.data),
  estado: (slug, estado) => axios.post(`${API_URL}/api/bodas/admin/${slug}/estado`, { estado }, staff()).then(r => r.data),
  eliminar: (slug) => axios.delete(`${API_URL}/api/bodas/admin/${slug}`, staff()).then(r => r.data),
  subirFoto: (slug, archivo) => {
    const datos = new FormData();
    datos.append('archivo', archivo, 'foto.jpg');
    return axios.post(`${API_URL}/api/bodas/admin/${slug}/foto`, datos, staff()).then(r => r.data);
  },
  quitarFoto: (slug) => axios.delete(`${API_URL}/api/bodas/admin/${slug}/foto`, staff()).then(r => r.data),
  urlFoto: (slug, version) => `${API_URL}/api/bodas/foto/${slug}?v=${version}`,
  urlFotoPareja: (slug, version) => `${API_URL}/api/bodas/foto/${slug}/pareja?v=${version}`,
  solicitudes: (params) => axios.get(`${API_URL}/api/bodas/solicitudes`, { ...staff(), params }).then(r => r.data),
  estadoSolicitud: (id, estado) => axios.put(`${API_URL}/api/bodas/solicitudes/${id}/estado`, { estado }, staff()).then(r => r.data),
  config: () => axios.get(`${API_URL}/api/bodas/admin/config`, staff()).then(r => r.data),
  guardarConfig: (datos) => axios.put(`${API_URL}/api/bodas/admin/config`, datos, staff()).then(r => r.data),
  buscarClientes: (search) => axios.get(`${API_URL}/api/clientes`, { ...staff(), params: { search, limit: 6 } }).then(r => r.data.clientes || []),
  publica: (slug) => axios.get(`${API_URL}/api/bodas/publica/${slug}`).then(r => r.data),
  referidoPublico: (codigo) => axios.get(`${API_URL}/api/referidos/publica/${codigo}`).then(r => r.data),
  miTarjeta: () => axios.get(`${API_URL}/api/mi-jpm/portal/mi-tarjeta-referidos`, cliente()).then(r => r.data),
  tarjetas: () => axios.get(`${API_URL}/api/bodas/tarjetas`, staff()).then(r => r.data),
  generarTarjeta: (clienteId) => axios.post(`${API_URL}/api/bodas/tarjetas/${clienteId}`, {}, staff()).then(r => r.data),
  beneficioPendiente: (params) => axios.get(`${API_URL}/api/bodas/beneficio-pendiente`, { ...staff(), params }).then(r => r.data),
  registroUrl: (variante, codigo) =>
    variante === 'referido' ? `${API_URL}/api/referidos/publica/${codigo}/registro` : `${API_URL}/api/bodas/publica/${codigo}/registro`,
};

export const mensajeError = (error, porDefecto) => {
  const detalle = error?.response?.data?.detail;
  if (typeof detalle === 'string') return detalle;
  if (Array.isArray(detalle) && detalle[0]?.msg) return detalle[0].msg.replace('Value error, ', '');
  return porDefecto || (error?.response?.status ? `Error ${error.response.status}` : 'Error de red. Inténtalo de nuevo.');
};
